import { animationSettingConstants } from "../constants/animationSettingConstants";
var UtilAnimationTicketManager = /** @class */ (function () {
    function UtilAnimationTicketManager() {
        var _this = this;
        this.animationPoolIds = new Map();
        this.requiredAnimationIds = new Map();
        this.activeAnimationIds = new Map();
        /**
         * Add an animation to the pool
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         * @param id
         * The id of the animation. (e.g: the animation of the building which is being animated)
         */
        this.addNewAnimationId = function (animationType, id) {
            if (!_this.isIdRegistered(animationType, id)) {
                _this.moveAnimationToPool(animationType, id);
            }
        };
        /**
         * Clear the animation from EVERY parameter.
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         * @param id
         * The id of the animation. (e.g: the animation of the building which is being animated)
         */
        this.clearAnimationId = function (animationType, id) {
            return _this.clearMatchingMapElement([_this.animationPoolIds, _this.requiredAnimationIds, _this.activeAnimationIds], animationType, id);
        };
        /**
         * Try to animate an animation. If it is successfully animated, move it to the animated
         * ones.
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         * @param id
         * The id of the animation. (e.g: the animation of the building which is being animated)
         * @param percentage
         * The chance of it being animated if it is not in the required animations.
         */
        this.animate = function (animationType, id, percentage) {
            // return false if maximum amount of animations is reached or if the animation is already
            // active.
            var isAnimationAlreadyActive = _this.isAnimationActive(animationType, id);
            var maxAnimationsReached = _this.maxAnimationsReached(animationType);
            if (isAnimationAlreadyActive || maxAnimationsReached) {
                return false;
            }
            // fill the required animations (only if needed).
            if (_this.needsTicketGeneration(animationType)) {
                _this.fillRequiredAnimationIds(animationType);
            }
            // either get the id from the required animations or go with the passed %
            var generationSucceeded = Math.floor(Math.random() * 100);
            var animationSucceeded = _this.requiredAnimationIds.get(animationType).indexOf(id) >= 0 ||
                generationSucceeded < percentage;
            if (animationSucceeded) {
                _this.moveToActiveAnimations(animationType, id);
            }
            return animationSucceeded;
        };
        /**
         * Stop the animation... It simply moves the animation back to the animationPool
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         * @param id
         * The id of the animation. (e.g: the animation of the building which is being animated)
         */
        this.stopAnimation = function (animationType, id) {
            return _this.moveAnimationToPool(animationType, id);
        };
        /**
         * Check if new animations are required.
         * The number of (required animations) + (active animations) needs to be the minimum between:
         * (number of total animations) and the minimum constant stored in animationSettingConstants.
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         */
        this.needsTicketGeneration = function (animationType) {
            var availableTickets = _this.getLengthSafe(_this.requiredAnimationIds, animationType);
            var activeTickets = _this.getLengthSafe(_this.activeAnimationIds, animationType);
            var buildingLength = _this.getLengthSafe(_this.animationPoolIds, animationType);
            var maximumAmountOfBuildings = activeTickets + availableTickets + buildingLength;
            var minWalkingCitizens = animationSettingConstants.minMaxConfigs.has(animationType)
                ? animationSettingConstants.minMaxConfigs.get(animationType).minAmount
                : 0;
            var minTickets = Math.min(maximumAmountOfBuildings, minWalkingCitizens);
            return activeTickets + availableTickets < minTickets;
        };
        /**
         * Fills the required animations until hte minimum is reached.
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         */
        this.fillRequiredAnimationIds = function (animationType) {
            if (!_this.requiredAnimationIds.has(animationType)) {
                _this.requiredAnimationIds.set(animationType, []);
            }
            // animationIds are generated randomly between the available ones
            while (_this.needsTicketGeneration(animationType)) {
                var availableBuildings = _this.animationPoolIds.get(animationType);
                var index = Math.floor(Math.random() * availableBuildings.length);
                _this.moveToRequiredAnimations(animationType, availableBuildings[index]);
            }
        };
        /**
         * Checks if the maximum amount of animations is reached for the given animationType.
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         */
        this.maxAnimationsReached = function (animationType) {
            var activeTickets = _this.activeAnimationIds.has(animationType)
                ? _this.activeAnimationIds.get(animationType).length
                : 0;
            return (animationSettingConstants.minMaxConfigs.has(animationType) &&
                activeTickets >= animationSettingConstants.minMaxConfigs.get(animationType).maxAmount);
        };
        /**
         * checks if the give animation is already part of the variables.
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         * @param id
         * The id of the animation. (e.g: the animation of the building which is being animated)
         */
        this.isIdRegistered = function (animationType, id) {
            return (_this.isAnimationActive(animationType, id) ||
                _this.isAnimationRequired(animationType, id) ||
                _this.isAnimationInPool(animationType, id));
        };
        /**
         * Checks if the given animation is already active
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         * @param id
         * The id of the animation. (e.g: the animation of the building which is being animated)
         */
        this.isAnimationActive = function (animationType, id) {
            return _this.activeAnimationIds.has(animationType) &&
                _this.activeAnimationIds.get(animationType).indexOf(id) >= 0;
        };
        /**
         * checks if the give animation is part of the animation pool.
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         * @param id
         * The id of the animation. (e.g: the animation of the building which is being animated)
         */
        this.isAnimationRequired = function (animationType, id) {
            return _this.requiredAnimationIds.get(animationType) != undefined &&
                _this.requiredAnimationIds.get(animationType).indexOf(id) >= 0;
        };
        /**
         * checks if the give animation is part of the required animations.
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         * @param id
         * The id of the animation. (e.g: the animation of the building which is being animated)
         */
        this.isAnimationInPool = function (animationType, id) {
            return _this.animationPoolIds.get(animationType) != undefined &&
                _this.animationPoolIds.get(animationType).indexOf(id) >= 0;
        };
        /**
         * moves the given animation to the pool.
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         * @param id
         * The id of the animation. (e.g: the animation of the building which is being animated)
         */
        this.moveAnimationToPool = function (animationType, id) {
            _this.setMapsElementSafe([_this.animationPoolIds], animationType, id);
            _this.clearMatchingMapElement([_this.requiredAnimationIds, _this.activeAnimationIds], animationType, id);
        };
        /**
         * moves the given animation to the required animations.
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         * @param id
         * The id of the animation. (e.g: the animation of the building which is being animated)
         */
        this.moveToRequiredAnimations = function (animationType, id) {
            _this.setMapsElementSafe([_this.requiredAnimationIds], animationType, id);
            _this.clearMatchingMapElement([_this.activeAnimationIds, _this.animationPoolIds], animationType, id);
        };
        /**
         * moves the given animation to the active animations.
         * @param animationType
         * The animation type of the animation. (e.g: walking citizen)
         * @param id
         * The id of the animation. (e.g: the animation of the building which is being animated)
         */
        this.moveToActiveAnimations = function (animationType, id) {
            _this.setMapsElementSafe([_this.activeAnimationIds], animationType, id);
            _this.clearMatchingMapElement([_this.requiredAnimationIds, _this.animationPoolIds], animationType, id);
        };
        // TODO: this can be moved to an util or a library and can be generalized for <T, T>
        /**
         * Helper function to set a value in an array inside a map.
         * @param mapsToSet the map which requires to be set
         * @param animationType the type of the animation.
         * @param id the id to set.
         */
        this.setMapsElementSafe = function (mapsToSet, animationType, id) {
            return mapsToSet.forEach(function (map) {
                if (!map.has(animationType)) {
                    map.set(animationType, []);
                }
                if (map.get(animationType).indexOf(id) < 0) {
                    map.get(animationType).push(id);
                }
            });
        };
        // TODO: this can be moved to an util or a library and can be generalized for <T, T>
        /**
         * Helper function get the length of a value in an array inside a map.
         * @param mapToUse the map which requires to be read
         * @param animationType the type of the animation.
         */
        this.getLengthSafe = function (mapToUse, animationType) { return (mapToUse.has(animationType) ? mapToUse.get(animationType).length : 0); };
        // TODO: this can be moved to an util or a library and can be generalized for <T, T>
        /**
         * Helper function to remove a value in an array inside a map.
         * @param mapsToClear the map which requires to be cleared of the value
         * @param animationType the type of the animation.
         * @param id the id to remove.
         */
        this.clearMatchingMapElement = function (mapsToClear, animationType, id) {
            return mapsToClear.forEach(function (element) {
                return element.set(animationType, element.has(animationType)
                    ? element.get(animationType).filter(function (innerElement) { return innerElement !== id; })
                    : []);
            });
        };
    }
    return UtilAnimationTicketManager;
}());
export var utilAnimationTicketManager = new UtilAnimationTicketManager();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilAnimationTicketManager.ts
// module id = 2199
// module chunks = 3